// extracted by mini-css-extract-plugin
export default {"container":"Inicio_container__vZzFw","containerContenido":"Inicio_containerContenido__zgJwV","containerCategorias":"Inicio_containerCategorias__pLAqY"};